import type { FundReportData } from 'commons/modules/service/founds';
import { createReportSlice } from './reportStore';

// Initial filter keys for Funds report
const initialFilters = {
  policyNumber: '',
  clientId: '',
  brokerageHouseId: '',
  fundKey: '',
  fundType: '',
  adviser: '',
  portfolio: '',
  strategy: '',
};

// Create generic slice instance for this report
const slice = createReportSlice<FundReportData>(
  'operationFounds',
  initialFilters,
);

// Reducer
export default slice.reducer;
